import {
  createColumn,
  createDropdownColumn,
  createCheckboxColumn
} from "../components/Table/Table";

export const escalatorRTDColumns: State.Column[] = [
  createColumn(
    "Code",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.code,
    "escalatorRTD.code",
    true,
    80
  ),
  createDropdownColumn(
    "RTD Group",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.rtdGroupEnumName, //check this
    "escalatorRTD.rtdGroupEnumName",
    true,
    240
  ),
  createColumn(
    "Sw Name",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.swName,
    "escalatorRTD.swName",
    true,
    300
  ),
  createColumn(
    "Unit Name",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.unitName,
    "escalatorRTD.unitName",
    true,
    200
  ),
  createColumn(
    "English Name",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.name,
    "escalatorRTD.name",
    true
  ),
  createColumn(
    "Description",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.description,
    "escalatorRTD.description",
    true
  ),
  createCheckboxColumn(
    "Localizable",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.localizable,
    "escalatorRTD.localizable",
    true,
    100
  ),
  createColumn(
    "Created By",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.createdBy,
    "escalatorRTD.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.createdDate,
    "escalatorRTD.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.modifiedBy,
    "escalatorRTD.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (escalatorRTD: Api.EscalatorRTD) => escalatorRTD.modifiedDate,
    "escalatorRTD.modifiedDate",
    false
  )
];

export const escalatorRTDGroupColumns: State.Column[] = [
  createColumn(
    "Enum Value",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.enumValue,
    "escalatorRTDGroup.enumValue",
    true
  ),
  createColumn(
    "Enum Name",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.enumName,
    "escalatorRTDGroup.enumName",
    true
  ),
  createColumn(
    "Description",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.description,
    "escalatorRTDGroup.description",
    true
  ),
  createColumn(
    "English Name",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.name,
    "escalatorRTDGroup.name",
    true
  ),
  createColumn(
    "Created By",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.createdBy,
    "escalatorRTDGroup.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.createdDate,
    "escalatorRTDGroup.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.modifiedBy,
    "escalatorRTDGroup.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (escalatorRTDGroup: Api.EscalatorRTDGroup) => escalatorRTDGroup.modifiedDate,
    "escalatorRTDGroup.modifiedDate",
    false
  )
];


export const escalatorDataActCodeColumns: State.Column[] = [
  createColumn(
    "Code",
    (escalatorDataActCode: Api.EscalatorDataActCode) => escalatorDataActCode.code,
    "escalatorDataActCode.code",
    true
  ),
  createColumn(
    "Name",
    (escalatorDataActCode: Api.EscalatorDataActCode) => escalatorDataActCode.name,
    "escalatorDataActCode.name",
    true
  ),
  createColumn(
    "Created By", 
    (escalatorDataActCode: Api.EscalatorDataActCode) => escalatorDataActCode.createdBy, 
    "escalatorDataActCode.createdBy", 
    false),
  createColumn(
    "Created Date",
    (escalatorDataActCode: Api.EscalatorDataActCode) => escalatorDataActCode.createdDate,
    "escalatorDataActCode.createdDate",
    false
  ),
  createColumn(
    "Modified By", 
    (escalatorDataActCode: Api.EscalatorDataActCode) => escalatorDataActCode.modifiedBy, 
    "escalatorDataActCode.modifiedBy", 
    false),
  createColumn(
    "Modified Date",
    (escalatorDataActCode: Api.EscalatorDataActCode) => escalatorDataActCode.modifiedDate,
    "escalatorDataActCode.modifiedDate",
    false
  )
];

export const escalatorEventLogColumns: State.Column[] = [
  createColumn(
    "Event Code",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.eventCode,
    "escalatorEventLog.eventCode",
    true,
    100
  ),
  createColumn(
    "Event Name",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.eventName,
    "escalatorEventLog.eventName",
    true,
    240
  ),
  createDropdownColumn(
    "Additional Data1",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.data1EnumName,
    "escalatorEventLog.data1EnumName",
    true,
    240
  ),
  createColumn(
    "Data1 Unit Name",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.data1UnitName,
    "escalatorEventLog.data1UnitName",
    true,
    100
  ),
  createColumn(
    "Data1 Decimal Digits",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.data1DecimalDigits,
    "escalatorEventLog.data1DecimalDigits",
    true,
    100
  ),
  createDropdownColumn(
    "Additional Data2",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.data2EnumName,
    "escalatorEventLog.data2EnumName",
    true,
    240
  ),
  createColumn(
    "Data2 Unit Name",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.data2UnitName,
    "escalatorEventLog.data2UnitName",
    true,
    100
  ),
  createColumn(
    "Data2 Decimal Digits",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.data2DecimalDigits,
    "escalatorEventLog.data2DecimalDigits",
    true,
    100
  ),
  createColumn(
    "English Name",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.name,
    "escalatorEventLog.name",
    true
  ),
  createColumn(
    "Description",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.description,
    "escalatorEventLog.description",
    true
  ),
  createColumn(
    "Created By",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.createdBy,
    "escalatorEventLog.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.createdDate,
    "escalatorEventLog.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.modifiedBy,
    "escalatorEventLog.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (escalatorEventLog: Api.EscalatorEventLog) => escalatorEventLog.modifiedDate,
    "escalatorEventLog.modifiedDate",
    false
  )
];